import {
  InjectionToken, Provider, Type,
} from '@angular/core'

export const DEVICE_TYPE_SERVICE_TOKEN = new InjectionToken<DeviceTypeService>('DeviceTypeService')

export function provideDeviceTypeService(service: Type<DeviceTypeService>): Provider {
  return {
    provide: DEVICE_TYPE_SERVICE_TOKEN,
    useClass: service,
  }
}

export type DeviceType = 'console' | 'mobile' | 'tablet' | 'smarttv' | 'wearable' | 'embedded'

export interface DeviceTypeService {

  isMobile(): boolean | undefined

}
